/**
 * @prettier
 */

// React Packages
import { useEffect, useRef, useState } from 'react';
import Header from './Header';
import { useTranslation } from 'react-i18next';

// Images
import { imageAlt } from '../config/accessabilityRules';

// Components
import LoadingMessages from '../components/Messages/LoadingMessages';
import AnalysingSVG from '../assets/svg/AnalysingAnimation.svg';

// Configs
import LOADING_MESSAGE_CONFIG from '../config/loadingMessageConfig';
import { connect } from 'react-redux';

export const LoadingStateAnimation = () => (
    <div id='loader-animation' aria-label={imageAlt.loading} />
);

const ProcessingLayout = ({ documentData, callType = '', showMessages }) => {
    const [imageAltText, setImageAltText] = useState(imageAlt.loading);
    const primaryFocusRef = useRef();
    const { t } = useTranslation();

    // Check if loading during classification or verification call
    const setMessagesToAnimate = () => {
        return callType === 'verify'
            ? LOADING_MESSAGE_CONFIG.verify
            : LOADING_MESSAGE_CONFIG.classify;
    };

    useEffect(() => {
        document.title = t('idpal_doc_title_processing');
        if (documentData?.properties?.documentId === 1) {
            setImageAltText(imageAlt.loading);
        } else {
            setImageAltText(imageAlt.idCardLoading);
        }

        // Sets focus to primary heading on first render
        if (primaryFocusRef && primaryFocusRef.current) {
            primaryFocusRef.current.focus();
        }
    }, [documentData?.properties?.documentId, t]);

    return (
        <div className='root-layout-container processing-layout'>
            <Header />
            <object
                className='svg-animation-container'
                data={AnalysingSVG}
                aria-label={imageAltText}
            />
            {showMessages && (
                <LoadingMessages messageConfig={setMessagesToAnimate()} />
            )}
        </div>
    );
};
function mapStateToProps(state) {}
export default connect(mapStateToProps)(ProcessingLayout);
